module.exports = __webpack_public_path__ + "static/media/yellowseed-sponsor.fca761f2.jpeg";